import React, { useState, useEffect } from "react";
import "./Header.css";
import { Link } from "react-router-dom";
import { path } from "framer-motion/client";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
const Header = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [isSticky, setSticky] = useState(false);
  const location = useLocation();

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const navigate = useNavigate();
  const menuItems = [
    { name: "Home", path: "/" },
    // { name: "Pages", path: "/" },
    { name: "Services", path: "/services" },
    { name: "Detailing Services", path: "/detailing" },
    { name: "Packages", path: "/" },
    { name: "Contact", path: "/" },

    { name: "About", path: "/about" },

    // { name: "Shop", path: "/" },
    // { name: "Blog", path: "/" },
  ];
  // const handleScroll = (event, id) => {
  //   event.preventDefault();
  //   const section = document.getElementById(id);
  //   if (section) {
  //     const yOffset = -210;
  //     const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
  //     window.scrollTo({ top: y, behavior: "smooth" });
  //   }
  // };

  const handleScroll = (event, id) => {
    if (window.innerWidth < 1024) {
      console.log("calls");
      toggleSidebar();
    }
    event.preventDefault();
    const currentPath = window.location.pathname;
    if (currentPath !== "/") {
      navigate("/", { state: { scrollTo: id } });
    } else {
      const section = document.getElementById(id);
      if (section) {
        const yOffset = -210;
        const y =
          section.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  };

  return (
    <>
      <header className={`header ${isSticky ? "sticky" : ""}`}>
        {/* <div className="logo"> */}

        {/* <span className="logo-text">
            <span className="pro">PRO</span>
            <span className="motors">MOTORS</span>
          </span> */}
        {/* </div> */}
        <div className="logo">
          <a href="/">
            {" "}
            <img
              src="/assets/logo/Ezer.png"
              alt="Logo"
              className="logo-image"
            />
          </a>
        </div>
        <div className="right-items">
          {/* <div className="mob-contact-box">
            <button onClick={() => window.open('https://booking.auxosoftware.com/w+WbahyJ_ES6NxDj+gBwFA==', '_blank')}>
              Book Appointment Mobile
            </button>
          </div> */}
          {/* <div className="mobile-only">
            <img src="/assets/MTA.png" className="side-image mobile-only" />
            <div className="mob-contact-box ">

              <button onClick={() => window.open('https://booking.auxosoftware.com/w+WbahyJ_ES6NxDj+gBwFA==', '_blank')}>
                Book Appointment Mobile
              </button>
            </div>
          </div> */}

          <div className="mobile-only">
            <img src="/castrol.png" alt="Castrol" className="mob-partner-img" />
            <img src="/assets/MTA.png" alt="MTA" className="mob-partner-img" />
            <button
              className="mob-book-button"
              onClick={() =>
                window.open(
                  "https://booking.auxosoftware.com/w+WbahyJ_ES6NxDj+gBwFA==",
                  "_blank",
                )
              }
            >
              Book Appointment
            </button>
          </div>

          <div className="menu-icon" onClick={toggleSidebar}>
            <i className="fa fa-bars" aria-hidden="true"></i>
          </div>
        </div>

        <nav className="nav">
          <Link to="/" className="nav-link">
            Home
          </Link>

          <Link to="/about" className="nav-link">
            About
          </Link>

          <Link to="/services" className="nav-link">
            Services
          </Link>
          <Link to="/detailing" className="nav-link">
            Detailing Services
          </Link>

          <Link
            to="/"
            onClick={(event) => handleScroll(event, "packages")}
            className="nav-link"
          >
            Packages
          </Link>
          <Link
            to="/"
            onClick={(event) => handleScroll(event, "contact")}
            className="nav-link"
          >
            Contact
          </Link>
        </nav>

        {/* <div className="contact-box">
          <button onClick={() => window.open('https://booking.auxosoftware.com/w+WbahyJ_ES6NxDj+gBwFA==', '_blank')}>Book Appointment Desktop</button>
        </div> */}
        {/* <div className="desktop-only">
          <img src="/assets/MTA.png" alt="Desktop Icon" className="side-image desktop-only" />
          <div className="contact-box">
            <button onClick={() => window.open('https://booking.auxosoftware.com/w+WbahyJ_ES6NxDj+gBwFA==', '_blank')}>
              Book Appointment Desktop
            </button>
          </div>
        </div> */}

        <div className="cta-container">
          <img src="/castrol.png" alt="Castrol" className="cta-image" />
          <img src="/assets/MTA.png" alt="MTA" className="cta-image" />
          <button
            className="cta-button"
            onClick={() =>
              window.open(
                "https://booking.auxosoftware.com/w+WbahyJ_ES6NxDj+gBwFA==",
                "_blank",
              )
            }
          >
            Book Appointments
          </button>
        </div>
      </header>

      <aside className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <div className="sidebar-inner">
          <div className="sidebar-top">
            <div className="sidebar-header">
              <div className="logo">
                <img
                  src="/assets/logo/Ezer.png"
                  alt="Logo"
                  className="logo-image"
                />
              </div>
              <div className="sidebar-close" onClick={toggleSidebar}>
                <i className="fa fa-times" aria-hidden="true"></i>
              </div>
            </div>

            <div className="sidebar-links">
              <div className="sidebar-item">
                <Link
                  to="/"
                  onClick={() => isSidebarOpen && toggleSidebar()}
                  style={{ textDecoration: "none" }}
                >
                  <span
                    className="item-text"
                    style={{ textDecoration: "none", color: "#ccc" }}
                  >
                    Home
                  </span>
                </Link>
              </div>

              <div className="sidebar-item">
                <Link
                  to="/about"
                  onClick={() => isSidebarOpen && toggleSidebar()}
                  style={{ textDecoration: "none" }}
                >
                  <span
                    className="item-text"
                    style={{ textDecoration: "none", color: "#ccc" }}
                  >
                    About
                  </span>
                </Link>
              </div>
              <div className="sidebar-item">
                <Link
                  to="/services"
                  onClick={() => isSidebarOpen && toggleSidebar()}
                  style={{ textDecoration: "none" }}
                >
                  <span
                    className="item-text"
                    style={{ textDecoration: "none", color: "#ccc" }}
                  >
                    Service
                  </span>
                </Link>
              </div>
              <div className="sidebar-item">
                <Link
                  to="/detailing"
                  onClick={() => isSidebarOpen && toggleSidebar()}
                  style={{ textDecoration: "none" }}
                >
                  <span
                    className="item-text"
                    style={{ textDecoration: "none", color: "#ccc" }}
                  >
                    Detailing Services
                  </span>
                </Link>
              </div>
              <div className="sidebar-item">
                <Link
                  onClick={(event) => handleScroll(event, "packages")}
                  style={{ textDecoration: "none" }}
                >
                  <span
                    className="item-text"
                    style={{ textDecoration: "none", color: "#ccc" }}
                  >
                    Packages
                  </span>
                </Link>
              </div>
              <div className="sidebar-item">
                <Link
                  onClick={(event) => handleScroll(event, "contact")}
                  style={{ textDecoration: "none" }}
                >
                  <span
                    className="item-text"
                    style={{ textDecoration: "none", color: "#ccc" }}
                  >
                    Contact
                  </span>
                </Link>
              </div>
            </div>
          </div>

          <div className="sidebar-partners">
            <span className="sidebar-partners__title font-mulish">
              Authorised Partner
            </span>
            <div className="sidebar-partners__logos">
              <img
                src="/castrol.png"
                alt="Castrol"
                className="sidebar-partner-img"
              />
              <img
                src="/assets/MTA.png"
                alt="MTA"
                className="sidebar-partner-img"
              />
            </div>
          </div>
        </div>
      </aside>
      {isSidebarOpen && (
        <div className="sidebar-backdrop" onClick={toggleSidebar} />
      )}
    </>
  );
};

export default Header;
